<template>
  <div class="bAdmins">
    <div class="bAdmins__container container pt-4">
      <div class="bAdmins__header row">
        <div class="bAdmins__header__h2 h2 col">管理員管理</div>
      </div>
      <div class="bAdmins__body row">
        <form class="col-12 col-md-6 col-lg-4 mb-3"
        v-for="(item, index) in admins"
        :key="index">
            <b-button
            v-b-toggle="`admin${index}`"
            class="mb-1 w-100 d-flex flex-column align-items-center">
              <span>{{item.name}}</span>
            </b-button>
            <b-collapse :id="`admin${index}`">
              <b-card class="p-0">
                <ul class="list-group">
                  <li class="list-group-item
                  border-top-0 border-left-0 border-right-0
                  d-flex justify-content-between align-items-center">
                    <span class="pr-2">管理員ID</span>
                    <span>
                      {{item.id}}
                    </span>
                  </li>
                  <li class="list-group-item
                  border-top-0 border-left-0 border-right-0
                  d-flex justify-content-between align-items-center">
                    <span class="pr-2">管理員姓名</span>
                    <span v-if="!item.editing">
                      {{item.name}}
                    </span>
                    <input v-if="item.editing"
                    type="text" class="form-control" v-model="item.name">
                  </li>
                  <li class="list-group-item
                  border-top-0 border-left-0 border-right-0
                  d-flex justify-content-between align-items-center">
                    <span class="pr-2">管理員權限</span>
                    <span>
                      {{item.level}}
                    </span>
                  </li>
                  <li class="list-group-item border-0
                  d-flex justify-content-end align-items-center">
                    <button class="btn btn-sm btn-info"
                    @click.prevent="start_editing_admin(index)"
                    v-if="admin.id === item.id && !item.editing">
                      編輯資料
                    </button>
                    <button class="btn btn-sm btn-success mr-2"
                    @click.prevent="submit_editing_admin(index)"
                    v-if="admin.id === item.id && item.editing">
                      儲存變更
                    </button>
                    <button class="btn btn-sm btn-secondary"
                    @click.prevent="initialize_admins"
                    v-if="admin.id === item.id && item.editing">
                      放棄編輯
                    </button>
                    <button class="btn btn-sm btn-danger"
                    @click.prevent="confirm_delete_admin(index)"
                    v-if="admin.level < item.level">
                      刪除管理員
                    </button>
                  </li>
                </ul>
              </b-card>
            </b-collapse>
        </form>
        <form class="col-12 col-md-6 col-lg-4 mb-3"
        @submit.prevent="add_admin">
            <b-button
            variant="primary"
            v-b-toggle="'newAdmin'"
            class="mb-1 w-100 d-flex flex-column align-items-center">
              <span>新增管理員</span>
            </b-button>
            <b-collapse id="newAdmin">
              <b-card class="p-0">
                <ul class="list-group">
                  <li class="list-group-item
                  border-top-0 border-left-0 border-right-0
                  d-flex justify-content-between align-items-center">
                    <span class="pr-2">管理員ID</span>
                    <input type="text" class="form-control" required
                    v-model="newAdmin.id">
                  </li>
                  <li class="list-group-item
                  border-top-0 border-left-0 border-right-0
                  d-flex justify-content-between align-items-center">
                    <span class="pr-2">管理員姓名</span>
                    <input type="text" class="form-control" required
                    v-model="newAdmin.name">
                  </li>
                  <li class="list-group-item
                  border-top-0 border-left-0 border-right-0
                  d-flex justify-content-between align-items-center">
                    <span class="pr-2">管理員權限</span>
                    <input type="number" class="form-control" required
                    v-model="newAdmin.level"
                    :min="admin.level + 1" step="1">
                  </li>
                  <li class="list-group-item border-0
                  d-flex justify-content-end align-items-center">
                    <button class="btn btn-sm btn-success mr-2"
                    type="submit">
                      新增管理員
                    </button>
                    <button class="btn btn-sm btn-secondary"
                    @click.prevent="refresh_newAdmin">
                      清除重填
                    </button>
                  </li>
                </ul>
              </b-card>
            </b-collapse>
        </form>
      </div>
    </div>
    <b-modal id='confirm_delete_admin'
    title="確認"
    ok-title='是'
    cancel-title='否'
    @ok='delete_admin(deletingAdmin.id)'>
      <p class="my-3">確定要刪除嗎?</p>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ['admin'],
  data() {
    return {
      admins: [],
      newAdmin: {},
      deletingAdmin: {},
    };
  },
  methods: {
    initialize_admins() {
      this.$bus.$on('son_get_data', (data) => {
        this.admins = JSON.parse(JSON.stringify(data.administrators));
      });
      this.$bus.$emit('son_call_data');
      this.admins.forEach((item) => {
        this.$set(item, 'editing', false);
      });
    },
    refresh_newAdmin() {
      const adminLevel = this.admin.level;
      this.newAdmin = {
        id: '',
        name: '',
        account: '',
        password: '',
        level: adminLevel + 1,
      };
    },
    add_admin() {
      const ifIdRepeated = () => {
        let boolean;
        const newId = this.newAdmin.id;
        const hasUsed = this.admins.find((item) => item.id === newId);
        if (hasUsed === undefined) {
          boolean = true;
        } else {
          boolean = false;
        }
        return boolean;
      };
      if (ifIdRepeated()) {
        const newAdminObj = JSON.parse(JSON.stringify(this.newAdmin));
        this.$bus.$emit('add_new_admin', newAdminObj);
        this.initialize_admins();
        this.refresh_newAdmin();
      } else {
        this.$bus.$emit('show_toast', 'warning', '此 ID 已被使用');
      }
    },
    confirm_delete_admin(index) {
      const deletingTarget = this.admins[index];
      this.deletingAdmin = deletingTarget;
      this.$bvModal.show('confirm_delete_admin');
    },
    delete_admin(id) {
      this.$bus.$emit('delete_admin', id);
      this.initialize_admins();
      this.deletingAdmin = {};
    },
    start_editing_admin(index) {
      this.admins[index].editing = true;
    },
    submit_editing_admin(index) {
      const editedItem = JSON.parse(JSON.stringify(this.admins[index]));
      delete editedItem.editing;
      this.$bus.$emit('edit_admin', index, editedItem);
      this.initialize_admins();
    },
  },
  created() {
    this.initialize_admins();
    this.refresh_newAdmin();
  },
};
</script>
